<div id="audioController" class="audio-controller unselectable stopped {{audio_status}}">
  <button id="{{cid}}-audioButton" class="audio-button {{audio_status}} {{button_class}}" data-state="{{audio_status}}">{{display_status}}</button>
  <div class="audio-wrapper">
    <div class="timestamp-container">
      <span id="audioTime" class="time-display" role="timer">{{position}}</span>
      <span style="color: white">/</span>
      <span id="audioRemaining" class="duration-display hidden" role="timer">{{remaining}}</span>
      <span id="audioDuration" class="duration-display" tabindex="0">{{duration}}</span>
    </div>
    <div id="muteBtn" class="btn-mute control-icon-layout">
      <button tabindex="0"><span id="iconMute" class="{{#if muted}}icon-mute-on{{else}}icon-mute-off{{/if}}"></span></button>
    </div>
    <input type="range" id="volumebar" class="volumebar" value="{{audio_volume}}" min="0" max="1" step="0.1" aria-valuetext="100%"/>
  </div>
</div>
